import Link from 'next/link'
import React from 'react'
import TextSection from './core/TextSection'

const YouMightAlsoLike = () => {
  return (
    <TextSection
      h3='You might also like'
      p={
        <ul className='list-disc space-y-1 pl-5'>
          <li>
            <Link href='/memes/customer-service-memes' className='underline'>
              Customer Service Memes
            </Link>
          </li>
          <li>
            <Link href='/memes/marketing-memes' className='underline'>
              Marketing Memes
            </Link>
          </li>
          <li>
            <Link href='/memes/sales-memes' className='underline'>
              Sales Memes
            </Link>
          </li>
          <li>
            <Link href='/memes/product-manager-memes' className='underline'>
              Product Manager Memes
            </Link>
          </li>
          <li>
            <Link href='/memes/meetings-memes' className='underline'>
              Meetings Memes
            </Link>
          </li>
          <li>
            <Link href='/memes/zoom-meetings-memes' className='underline'>
              Zoom Meetings Memes
            </Link>
          </li>
          <li>
            <Link href='/memes/memes-for-coworkers' className='underline'>
              Coworker Memes
            </Link>
          </li>
          <li>
            <Link href='/memes/thursday-work-memes' className='underline'>
              Thursday Work Memes
            </Link>
          </li>
          <li>
            <Link href='/memes/memes-about-work' className='underline'>
              Memes about work
            </Link>
          </li>
          <li>
            <Link href='/memes/memes-about-memes' className='underline'>
              Memes about memes
            </Link>
          </li>
          <li>
            <Link href='/memes/travel-memes' className='underline'>
              Travel Memes
            </Link>
          </li>
        </ul>
      }
    />
  )
}

export default YouMightAlsoLike
